enum OrderBookType {
  Buy,
  Sell,
}

export default OrderBookType;
